import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar/index";
import Header from "./Header/index";
import { useState } from "react";
import { motion } from "framer-motion";

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    
    return (
        <div className="dark:bg-boxdark-2 dark:text-bodydark bg-gray-50 font-verdana h-screen overflow-hidden">
            <div className={`flex h-full overflow-hidden`}>
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden bg-gray-50">
                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <main className="flex-1 bg-gray-50 w-full overflow-y-auto">
                        <motion.div 
                            className="w-full"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.3 }}
                        >
                            <Outlet />
                        </motion.div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Layout;